import { Component } from '@angular/core';
import { CustomersTableComponent } from './customers-table/customers-table.component';
import { MdbButtonComponent } from '../../utils/mdb-button/mdb-button.component';
import { NewCustomerModalComponent } from './new-customer-modal/new-customer-modal.component';
import { CustomNotificationService } from '../../../services/utils/custom-notification.service';
import { MdbModalService } from 'mdb-angular-ui-kit/modal';
import { CustomerService } from '../../../services/resources/customer.service';

@Component({
  selector: 'app-customers',
  imports: [
    CustomersTableComponent,
    MdbButtonComponent
  ],
  templateUrl: './customers.component.html',
  styleUrl: './customers.component.scss'
})
export class CustomersComponent {
  constructor(
    private notificationService: CustomNotificationService,
    private modalService: MdbModalService,
    private customerService: CustomerService
  ) {}
  openNewCustomerModal() {
    this.customerService.getAll({ paginated: false });
    let modalRef = this.modalService.open(NewCustomerModalComponent, {
      modalClass: 'modal-xl',
      ignoreBackdropClick: true,
    });
    modalRef.onClose.subscribe((customer) => {
      if (!customer)
        return;

      this.notificationService.success('CUSTOMERS.SUCCESSFULLY_CREATED');
    });
  }
}
